var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1462.000000pt",
    height: "1398.000000pt",
    viewBox: "0,0,256,244.78125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.08755,-0.09364) scale(0.1751,0.1751)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1398) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,13957c-3,-7 -4,-149 -3,-317l3,-305l2223,-3l2222,-2v-1905v-1905h-2225h-2225v-315v-315h2540h2540v1110v1110h2225h2225v-4125v-4125h-2225h-2225v1110v1110l-2537,-2l-2538,-3v-315v-315l2223,-3l2222,-2v-1905v-1905h-2225h-2225v-315v-315h2540h2540v1110v1110h2540h2540l2,2222l3,2223l2223,3l2222,2v315v315h-2225h-2225v2225v2225h-2540h-2540v1110v1110h-2535c-2030,0 -2537,-3 -2540,-13z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracket);
export default __webpack_public_path__ + "static/media/bracket.b2dc15bb113e11528a64651ac692c5cc.svg";
export { ForwardRef as ReactComponent };